<template>
  <div id="app">
    <!-- the router outlet, where all matched components would ber viewed -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  metaInfo: {
    title: 'Broker Notes',
    titleTemplate: null
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue